import { ThemeConfig as ChakraThemeConfig } from '@chakra-ui/react';

export interface ThemeConfig extends ChakraThemeConfig {
  fontsPath: string;
}

export const config = {
  cssVarPrefix: 'ring',
  fontsPath: '/fonts',
} as ThemeConfig;
